export const ENDPOINTS_WITHOUT_AUTH = ['/authenticate', '/register'];
